#import "../../../../common/graphql/EntityDocumentsFields.graphql"
#import "../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

query GetPaymentDetails($id: UUID!) {
  payment(id: $id) {
    id
    _documentPackageId
    _isTransactionPayment
    payCycleId
    payCycle {
      description
      isDraft
    }
    company {
      id
      name
    }
    vendorId
    vendorReference
    memo
    paymentReference
    paidDate
    paidAmount
    rowSecurityId
    transactionTypeId
    _isUpdatable
    _isDeletable
    _isProtected
    _rowTimestamp
    _accountingStampDate
    _accountingStampTransactionReference
    _accountingStampUserId
    _accountingStampUserName
    _isAccountingEntryStampedComplete
    _isTransactionCancelled
    transactionType {
      id
      transactionType
    }
    _isApprovalDocumentsRequired
    _requiredApprovalDocuments
    currency {
      id
      isoCode
      name
    }
    userMessagesByEntityId {
      totalCount
    }
    invoicePayments {
      nodes {
        id
        _isTransactionPayment
        invoice {
          id
          description
          invoiceNumber
          vendorReference
          transactionType {
            id
            transactionType
            isDocumentSigningPayment
          }
          invoiceDate
          controlTotalAmount
        }
        _rowTimestamp
        _isUpdatable
        _isDeletable
      }
      aggregates {
        sum {
          appliedAmount
        }
      }
    }
    secureRowLevel {
      id
      name
      description
      securityLevel
    }
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
    paymentHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
        tenantUserName
      }
    }
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _tagBadgeColor
        _rowTimestamp
      }
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
    }
    lookupName {
      lookupName
      id
      isApprovedVendor
      lookupCode
      lookupName
      lookupName2
      address1
      address2
      city
      state
      zipCode
      country
      phone
      emailAccount
    }
    _emailDocument {
      ...EmailDocumentFields
    }
    emailDocumentsByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        ...EntityEmailDocumentsFields
      }
    }
  }
}
